module.exports = __webpack_public_path__ + "img/b.1c84d2c1.png";